import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14">

          {/* ── 清文華泉品牌 ── */}
          <div>
            <Link to="/" className="inline-block cursor-pointer">
              <img
                src="https://storage.readdy-site.link/project_files/5a105479-8d38-448e-9522-af2f638a0e72/43972714-abc7-46e0-b45a-08a831bb46bf_logo-02-01.png"
                alt="清文華泉事業有限公司 Cinva"
                className="h-10 w-auto rounded-sm"
              />
            </Link>
            <p className="mt-3 text-sm text-background-200 leading-relaxed max-w-[280px]">
              清文華泉事業有限公司
            </p>
            <p className="mt-1.5 text-sm text-foreground-400 leading-relaxed max-w-[280px]">
              AIGC 彩色書籍、科普與歷史類書籍
            </p>
            <p className="mt-3 text-xs text-foreground-400 leading-relaxed max-w-[280px]">
              本品牌委託崧博出版經銷，官方網站由崧博出版製作。
            </p>
            <p className="mt-2 text-xs text-foreground-500">
              官方網站{' '}
              <span className="text-foreground-400">cinva.sonbook.net</span>
            </p>
          </div>

          {/* ── 網站導覽 ── */}
          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">網站導覽</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  品牌介紹
                </Link>
              </li>
              <li>
                <a
                  href="/#2026-new-releases"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  2026 最新發行
                </a>
              </li>
              <li>
                <Link
                  to="/stores"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  合作通路
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  常見問題
                </Link>
              </li>
            </ul>
          </div>

          {/* ── 相關網站 ── */}
          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">相關網站</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://sonbook.net/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer group whitespace-nowrap"
                >
                  <span>崧博出版主站</span>
                  <i className="ri-external-link-line text-[10px] text-foreground-500 group-hover:text-background-50 transition-colors duration-200"></i>
                </a>
                <p className="mt-0.5 text-xs text-foreground-500 ml-0">
                  查看崧博出版與其他經銷品牌
                </p>
              </li>
              <li>
                <a
                  href="https://catalog.sonbook.net/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer group whitespace-nowrap"
                >
                  <span>崧博書籍資料庫</span>
                  <i className="ri-external-link-line text-[10px] text-foreground-500 group-hover:text-background-50 transition-colors duration-200"></i>
                </a>
                <p className="mt-0.5 text-xs text-foreground-500 ml-0">
                  查詢完整書名、作者與出版資訊
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* ── 書目資料說明 ── */}
        <div className="mt-12 pt-8 border-t border-foreground-800/50">
          <p className="text-xs text-foreground-500 leading-relaxed max-w-3xl mb-6">
            完整書名、作者、ISBN、內容主題、出版品牌及相關出版資訊，以崧博書籍資料庫中的個別書籍頁為準。網站中的「2026 最新發行」為清文華泉目前公開展示的新書內容。價格、版本、庫存與購買方式請以各合作購書通路頁面為準。
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {year} 清文華泉事業有限公司 Cinva。本品牌委託崧博出版經銷，官方網站由崧博出版製作。
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/faq"
                className="text-xs text-foreground-500 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                FAQ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}